import request from './plugins/request'

// 新建一条
export let createPartner = (params = {}) => {
    return request({
        url: '/partner',
        params: params,
        method: 'post'
    })
}

// 获取列表
export let getPartnerList = (params = {}) => {
    return request({
        url: '/partner',
        params: params
    })
}


//获取某一条的详情
export let getPartnerDetails = (params) => {
    return request({
        url: '/partner/'+params
    })
}

//删除某一条
export let deletePartner = (params) => {
    return request({
        url: '/partner/'+params,
        method: 'delete'
    })
}

//修改某一条
export let putPartner = (params,id) => {
    return request({
        url: '/partner/'+id,
        method: 'put',
        params: params
    })
}

